import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_NOTIFICATION_OVERVIEW_OPTIONS_API,
	GET_NOTIFICATION_COUNT_API,
	GET_NOTIFICATION_UNREAD_API,
	POST_NOTIFICATION_OVERVIEW_API,
	PUT_NOTIFICATION_READ_NOTIFICATIONID_API,
} from "@apis/apiPath";

const useNotificationApi = () => {
	const Ajax = useAjax();
	// const showLoading = useShowLoading();

	const getNotificationOverviewOptionsApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_NOTIFICATION_OVERVIEW_OPTIONS_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getNotificationCountApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_NOTIFICATION_COUNT_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getNotificationUnreadApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_NOTIFICATION_UNREAD_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const postNotificationOverviewApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_NOTIFICATION_OVERVIEW_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const putNotificationReadApi = useCallback(
		async id => {
			const resp = await Ajax.put(PUT_NOTIFICATION_READ_NOTIFICATIONID_API(id));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getNotificationOverviewOptionsApi,
		getNotificationCountApi,
		getNotificationUnreadApi,
		postNotificationOverviewApi,
		putNotificationReadApi,
	};
};

export default useNotificationApi;
